// Action
export const CLEAR_PERSISTENT_ERRORS = "CLEAR_PERSISTENT_ERRORS";
export const PERSISTENT_ERROR = "PERSISTENT_ERROR";
export const SET_ITEMS_TYPE = "SET_ITEMS_TYPE";
export const CLEAR_ERRORS = "CLEAR_ERRORS";
export const CLEAR_ERRORS_BY_TYPE = "CLEAR_ERRORS_BY_TYPE";
export const ERROR = "ERROR";
export const SET_ITEM_SAVED_STATUS = "SET_ITEM_SAVED_STATUS";
export const INITIALISED = "INITIALISED";
